export default [
  {
    title: "Introduction",
    body: "At HobbsTech Enterprises, we are committed to protecting the privacy and security of our users. This policy outlines how we collect, use, and protect your personal information.",
  },
  {
    title: "Information Collection",
    body: "We collect information to provide better services to all of our users. This includes information you provide when you use our services, like your name, email address, and payment information.",
  },
  {
    title: "Use of Information",
    body: "Your information is used to provide, maintain, and improve our services, as well as to develop new ones.",
  },
  {
    title: "Data Protection",
    body: "We implement robust security measures to protect your personal data. However, no method of transmission over the Internet or method of electronic storage is 100% secure.",
  },
  {
    title: "Your Rights",
    body: "You have rights under data protection laws in relation to your personal data, including the right to access, correct, or delete your personal data.",
  },
];
